import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ServicesRowOutline = (props: SvgIconProps) => {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.957 5.192a7.012 7.012 0 0 0 0 4.116c4.685.451 9.401.451 14.086 0a7.012 7.012 0 0 0 0-4.116a73.412 73.412 0 0 0-14.086 0ZM4.71 3.71a74.913 74.913 0 0 1 14.582 0c.535.053.984.419 1.148.925c.55 1.693.55 3.54 0 5.232a1.347 1.347 0 0 1-1.148.925a74.944 74.944 0 0 1-14.582 0a1.347 1.347 0 0 1-1.148-.925a8.508 8.508 0 0 1 0-5.232A1.347 1.347 0 0 1 4.71 3.71Zm.247 10.982a7.012 7.012 0 0 0 0 4.116c4.685.451 9.401.451 14.086 0a7.012 7.012 0 0 0 0-4.116a73.408 73.408 0 0 0-14.086 0ZM4.71 13.21a74.918 74.918 0 0 1 14.582 0c.535.053.984.419 1.148.925c.55 1.693.55 3.54 0 5.232a1.347 1.347 0 0 1-1.148.925a74.944 74.944 0 0 1-14.582 0a1.347 1.347 0 0 1-1.148-.925a8.508 8.508 0 0 1 0-5.232a1.347 1.347 0 0 1 1.148-.925Z"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};
